var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-social-linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    rx: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.63,
    y1: 10.89,
    x2: 7.63,
    y2: 16.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.38,16.89v-3a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.63,
    y1: 7.89,
    x2: 7.63,
    y2: 7.78
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e521ab27fd3e8dcfbe8463b7de8c223f.svg";
export { ForwardRef as ReactComponent };